import * as Sentry from '@sentry/react-router';
import { isRouteErrorResponse } from 'react-router';

import { CONTENT_OFFSET_CLASS } from '@/shared/configs/toolbar.config';
import type { Route } from '@/router-types/src/+types/root';

import { Container } from '@/components/common/Container';
import { ToolbarFallback } from '@/components/toolbar/ToolbarFallback';

export const RootErrorBoundary = ({ error }: Route.ErrorBoundaryProps) => {
  let message = 'Oops!';
  let details = 'An unexpected error occurred.';
  let stack: string | undefined;

  if (isRouteErrorResponse(error)) {
    message = error.status === 404 ? '404' : 'Error';
    details =
      error.status === 404 ? 'The requested page could not be found.' : error.statusText || details;
  } else if (error && error instanceof Error) {
    Sentry.captureException(error);

    if (import.meta.env.DEV) {
      details = error.message;
      stack = error.stack;
    }
  }

  return (
    <main>
      <ToolbarFallback />
      <div className={CONTENT_OFFSET_CLASS}>
        <Container className="flex-1 space-y-4 py-8">
          <h1 className="text-2xl font-bold">{message}</h1>
          <p>{details}</p>
          {stack && (
            <pre className="w-full overflow-x-auto p-4">
              <code>{stack}</code>
            </pre>
          )}
        </Container>
      </div>
    </main>
  );
};
